'use strict';

namespace Core {

    class DropdownCheckboxList {

        // Attrs
        model: any[];
        options: any[];
        caption: string;
        valueProperty: string;
        labelProperty: string;
        singularLabel: string;
        pluralLabel: string;

        private element: ng.IAugmentedJQuery;
        private isOpen: boolean = false;
        private eventNamespace = 'dropdowncheckboxlist';
        private ids: any;
        private selection: string;

        constructor (
            private $scope: ng.IScope,
            private $document: ng.IAugmentedJQuery,
            private resourceService: any
        ) {
        }

        init (el, attrs): void {
            this.element = el;

            const id = this.element.attr('id');
            this.ids = {
                button: id + '-button',
                menu: id + '-menu'
            };

            this.$scope.$watchCollection('dcl.model', val => {
                if (val) {
                    this.setButtonText();
                }
            });

            this.$scope.$watchCollection('dcl.options', val => {
                if (val) {
                    this.setButtonText();
                }
            });
        }

        public toggle(event): void {
            this.isOpen ? this.close() : this.open(event);
        }

        public keydown(event): void {
            switch (event.keyCode) {
                // Escape
                case 27:
                    this.close();
                    break;
                // Enter
                case 13:
                    this.toggle(event);
                    break;
                default:
            }
        }


        private setButtonText(): void {
            let label: string;

            if (!this.model || !this.options) {
                return;
            }

            if (this.model.length === this.options.length || this.model.length === 0) {
                label = this.resourceService.getDeferred('ANY')();
            } else if (this.model.length === 1) {
                let match = _.find(this.options, (o) => {
                    return o[this.valueProperty] === this.model[0];
                });
                label = String(match[this.labelProperty]);
            } else {
                label = `${this.model.length} ${this.pluralLabel}`;
            }
            this.selection = label;

        }

        private close(): void {
            if (!this.isOpen) {
                return;
            }
            this.isOpen = false;
            this.$document.off('.' + this.eventNamespace);
        }

        private open(event): void {
            this.isOpen = true;

            // close if background is clicked
            this.$document.on('mousedown.' + this.eventNamespace, (event) => {
                if (!this.isOpen) {
                    return;
                }
                // close if click target isn't the menu or the button
                if (!$(event.target).closest(`#${this.ids.menu}, #${this.ids.button}`).length) {
                    this.$scope.$apply(() => {
                        this.close();
                    });
                }
            });
        }

    }

    angular
        .module('core')
        .directive('dropdownCheckboxList', (): ng.IDirective => {
            return {
                restrict: 'E',
                scope: {},
                replace: true,
                controller: DropdownCheckboxList,
                controllerAs: 'dcl',
                bindToController: {
                    model: '=',
                    options: '=',
                    caption: '@',
                    valueProperty: '@',
                    labelProperty: '@',
                    singularLabel: '@',
                    pluralLabel: '@'

                },
                templateUrl: 'partials/home/directivetemplate?type=dropdowncheckboxlist',
                link: (
                    scope: ng.IScope,
                    el: ng.IAugmentedJQuery,
                    attrs: ng.IAttributes,
                    controller : DropdownCheckboxList
                ) => {
                    controller.init(el, attrs);
                }
            };
        });

}
